// src/common/services/permissionService.ts

import { useAuthStore } from '../../features/auth/store/authStore';

export const hasPermission = (permission: string): boolean => {
    const permissions = useAuthStore.getState().permissions;
  if (!permissions) {
    return false;
  }

  const [resource, action] = permission.split('.');

  if (!resource || !action) {
    console.warn(`Invalid permission format: ${permission}. Expected format "Resource.Action".`);
    return false;
  }

    for (const permissionGroup of permissions) {
        const permissionName = Object.keys(permissionGroup)[0];
    const permissionActions = permissionGroup[permissionName];
//      console.log("permission false", permissionName, ' action ', action, ' resource ', resource, permissionGroup[permissionName]);

        if (
            permissionName.toLowerCase() === resource.toLowerCase() &&
            permissionActions.map(a => a.toLowerCase()).includes(action.trim().toLowerCase())
        ) {
            // console.log("permission true", permissionName, ' action ', action);
            return true;
        }
  }

  return false;
};